// @flow
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from '../../utils'

export const Footer = styled<{}>('div', ({ $palette }) => ({
  flexGrow: 0,
  flexShrink: 0,
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'center',
  justifyContent: 'flex-end',
  borderTop: `1px solid ${$palette('gray')}`,
  ...getScreenStyles(
    'xs',
    {
      padding: '10px',
    },
    {
      padding: '20px',
    }
  ),
}))

export const InputContainer = styled('div', {
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  cursor: 'pointer',
  outline: 0,
  maxWidth: '100%',
})
